exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".panel-body {\n  padding: 5px !important; }\n\n.remove-pad-bottom {\n  margin-bottom: 0px !important; }\n\n.panel-box {\n  border: 1px solid #ddd;\n  border-radius: 4px; }\n\n.panel-box .panel {\n  border: none; }\n\n.panel-default > .panel-heading.cust-panel-color {\n  background-color: #ffffff;\n  border: none; }\n\n.panel-title {\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 400; }\n\n.panel-title a:hover, a:focus {\n  text-decoration: none;\n  outline: none;\n  outline-offset: 0; }\n\n.date-picker-margin {\n  margin-bottom: 5px;\n  margin-top: 5px; }\n\n.message-color {\n  color: blue; }\n\n.log-warning {\n  background-color: #ffe8e8 !important; }\n\n.log_style_container .wrap-text {\n  word-break: break-word; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/log/all/log.all.scss
// module id = 1055
// module chunks = 1